"use client";
import React from "react";
import { useInventoryNav } from "./InventoryNavContext";

/**
 * Visually disables (dims + blocks pointer interaction) its children while a
 * list-changing navigation is in flight. The functional guard lives in
 * InventoryNavContext (it makes the actions themselves no-ops); this is the
 * visual half so users see that the controls are temporarily inert.
 */
export default function DisableWhileNavigating({
  children,
  className = "",
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const { isNavigating } = useInventoryNav();

  return (
    <div
      className={`transition-opacity ${isNavigating ? "pointer-events-none opacity-60" : ""} ${className}`}
      aria-busy={isNavigating}
    >
      {children}
    </div>
  );
}
